<!--
 * @Description: 批改线上作业
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:20:33
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openXianShangZuoYe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">批改<span v-if="row.xsxm"> - {{ row.xsxm }}</span><span v-if="row.xsxh">({{ row.xsxh }})</span></span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openXianShangZuoYe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" class="wp100 hp100" label-width="140px">
        <el-container class="hp100">
          <el-aside width="200px" style="--el-aside-width: 200px;display: flex;flex-direction: column;justify-content: space-between;">
            <div class="dao-hang">
              <el-link v-for="(item,index) in data.listXianShangZuoYe" :key="index" :underline="false" :href="'#'+index">{{ index + 1 }}</el-link>
            </div>
            <div class="ping-jia">
              评价：
              <el-input v-model="data.py" :rows="10" type="textarea" resize="none" />
            </div>
          </el-aside>
          <el-main class="pt0 pr0 pb0">
            <el-card v-for="(item,index) in data.listXianShangZuoYe" :key="index" class="box-card mb10" :id="index" shadow="never">
              <template #header>
                <div class="card-header">
                  <span>第{{index + 1}}题</span>
                  <div>
                    <!-- <el-icon v-if="item.isDaAn === true" style="color: #F56C6C;"><Select /></el-icon>
                    <el-icon v-if="item.isDaAn === false" style="color: #F56C6C;"><CloseBold /></el-icon> -->
                  </div>
                </div>
              </template>
              <div class="shi-ti">
                <!-- 试题正文 -->
                <p style="white-space: pre-wrap; text-indent:0;" v-html="item.stzw"></p>
                <!-- 参考选项 -->
                <!-- 判断 -->
                <div v-if="item.txid === zytxData.panDuan">
                  <div>
                    <span class="mr10">正确答案：</span>
                    <span v-if="item.da === '对'">对</span>
                    <span v-if="item.da === '错'">错</span>
                  </div>
                  <div>
                    <span class="mr10">您的答案：</span>
                    <span v-if="item.jd === '对'">对</span>
                    <span v-if="item.jd === '错'">错</span>
                  </div>
                  <!-- 评分 -->
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题分数：</div>
                    <div>{{ item.fz }}分</div>
                  </div>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题得分：</div>
                    <div>{{ item.pingFen || 0 }}分</div>
                  </div>
                </div>

                <!-- 单项选择 -->
                <div v-else-if="item.txid === zytxData.danXuan">
                  <el-table v-if="item.listXuanXiang" class="mt10" :data="item.listXuanXiang" style="width: 100%" border :show-header="false">
                    <el-table-column align="center" width="80" show-overflow-tooltip>
                      <template #default="scope">
                        {{ scope.row.xxbh }}
                      </template>
                    </el-table-column>
                    <el-table-column align="left" show-overflow-tooltip>
                      <template #default="scope">
                        <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.xxnr"></p>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="display:flex; align-items: baseline;">
                    <div class="mr10">正确答案：</div>
                    <div class="mr10">{{ item.da }}</div>
                  </div>
                  <div style="display:flex; align-items: baseline;">
                    <div class="mr10">您的答案：</div>
                    <div class="mr10">{{item.jd}}</div>
                  </div>
                  <!-- 评分 -->
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题分数：</div>
                    <div>{{ item.fz }}分</div>
                  </div>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题得分：</div>
                    <div>{{ item.pingFen || 0 }}分</div>
                  </div>
                </div>

                <!-- 多项选择 -->
                <div v-else-if="item.txid === zytxData.duoXuan">
                  <el-table v-if="item.listXuanXiang" class="mt10" :data="item.listXuanXiang" style="width: 100%" border :show-header="false">
                    <el-table-column align="center" width="80" show-overflow-tooltip>
                      <template #default="scope">
                        {{ scope.row.xxbh }}
                      </template>
                    </el-table-column>
                    <el-table-column align="left" show-overflow-tooltip>
                      <template #default="scope">
                        <p style="white-space: pre-wrap; text-indent:0;" v-html="scope.row.xxnr"></p>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="display:flex; align-items: baseline;">
                    <div class="mr10">正确答案：</div>
                    <div class="mr10">{{ item.da }}</div>
                  </div>
                  <div style="display:flex; align-items: baseline;">
                    <div class="mr10">您的答案：</div>
                    <div class="mr10">{{item.jd}}</div>
                  </div>
                  <!-- 评分 -->
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题分数：</div>
                    <div>{{ item.fz }}分</div>
                  </div>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题得分：</div>
                    <div>{{ item.pingFen }}分</div>
                  </div>
                </div>
                <!-- 多文本解答 -->
                <div v-else>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10 mt10">正确答案：</div>
                      <p style="white-space: pre-wrap; text-indent:0;" v-html="item.da"></p>
                  </div>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10 mt10">您的答案：</div>
                      <p style="white-space: pre-wrap; text-indent:0;" v-html="item.jd"></p>
                  </div>
                  <!-- 评分 -->
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题分数：</div>
                    <div>{{ item.fz }}分</div>
                  </div>
                  <div class="mt10" style="display:flex; align-items: baseline;">
                    <div class="w70 mr10">本题得分：</div>
                    <div class="w150 mr10">
                      <el-input-number v-model="item.pingFen" :min="0" :max="item.fz" :precision="1" />
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </el-main>
        </el-container>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openXianShangZuoYe', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <el-backtop :right="100" :bottom="100" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { loadSelect, submitForm, closeWindow } from '@/api/common.js'
import { getTiXing } from '@/utils/zidianmeiju'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({
  openXianShangZuoYe: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openXianShangZuoYe', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})
const data = ref({ listXianShangZuoYe: [] })
const zytxData = ref({ list: [] })

// 提交
const submit = async () => {
  ruleForm.value.py = data.value.py
  try {
    data.value.listXianShangZuoYe.forEach((element, index) => {
      if (!element.pingFen && element.pingFen !== 0.00) {
        throw Number(index + 1)
      }
    })
  } catch (e) {
    return warningPrompt('第' + e + '题 未批改')
  }
  ruleForm.value.listPiGai = data.value.listXianShangZuoYe.map(item => ({ pf: item.pingFen, stid: item.stid }))
  submitForm({
    url: '/api/v2/ziyuanku/xueshengzuoye/jiaoshipigaixianshangzhengti',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openXianShangZuoYe', emits, true)
    }
  })
}

const row = ref()
watch(
  () => props.openXianShangZuoYe,
  () => {
    if (props.openXianShangZuoYe) {
      row.value = props.row
      zytxData.value = getTiXing()
      ruleForm.value.xszyid = props.row.id
      loadSelect({
        url: '/api/v2/ziyuanku/xueshengzuoye/xueshengzuoyexiangqing',
        data: data,
        parms: { xszyid: props.row.id },
        loadSuccess: function (res) {
          data.value.listXianShangZuoYe = res.data.listXianShangZuoYe.map(item => {
            item.pingFen = item.df
            return item
          })
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
.dao-hang {
  height: calc(100% - 280px);
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  :deep(.el-link) {
    margin: 5px;
    width: 40px;
    height: 40px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.biao-ti {
  padding: 15px 0;
  font-size: 16px;
}
</style>
